export default __webpack_public_path__ + "static/media/alethio1.20094107.png";